<template>
  <div
    class="category"
    @click="clickCategory"
  >
    <div class="header">
      <div>
        <i
          v-if="!isShow"
          class="el-icon-arrow-right"
          aria-hidden="true"
        />
        <i
          v-if="isShow"
          class="el-icon-arrow-down"
          aria-hidden="true"
        />
        設備類別：{{ data.Category }}
      </div>
    </div>
    <div
      v-if="isShow"
      class="body"
    >
      <div class="item-list-container">
        <Item
          v-for="item in data.Items"
          :key="item.TermId"
          :data="item"
          :category="data.Category"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Item from './Item'
export default {
  components: {
    Item
  },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    const isShow = false
    return {
      isShow
    }
  },
  methods: {
    clickCategory (e) {
      e.stopPropagation()
      this.isShow = !this.isShow
    }
  }
}
</script>

<style lang="scss" scoped>
.category {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .header {
    background-color: $bgDark3;
    padding: 15px;
    border-radius: 10px;
    border: 1px solid $borderDark4;
  }
  .item-list-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}
</style>
